import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { VideoResponseDto } from '../../common/general-types/videos.dto';
import { CreatorResponseDto } from '../../common/general-types/creators.dto';
import { FormatService } from '../../common/format/format.service';
import { SubmittedPostsService } from '../../services/submitted-posts/submitted-posts.service';
import { SuperSocialService } from '../../services/super-social/super-social.service';
import { take } from 'rxjs';
import { SubmittedPostDto, SubmittedPostVersionEnum } from '../../common/general-types/submitted-posts.dto';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'atom-individual-post-comments',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './individual-post-comments.component.html',
  styleUrl: './individual-post-comments.component.css'
})
export class IndividualPostCommentsComponent implements OnInit {

  @Input('applicationId') applicationId: string | undefined;
  @Input('video') video: VideoResponseDto | undefined;
  @Input('creator') creator: CreatorResponseDto | undefined;

  submittedPost = signal<SubmittedPostDto | undefined>(undefined);
  superSocialResults = signal<any | undefined>(undefined);
  individualResult = signal<any | undefined>(undefined);


  noSubmittedPosts = signal<boolean>(true);


  /** Services */
  private submittedPostsService = inject(SubmittedPostsService);
  private superSocialService = inject(SuperSocialService);
  public formatService = inject(FormatService);
  /** Services - END */

  ngOnInit(): void {
    console.log('🚨 IndividualPost - Comments -> ngOnInit');

    if (this.applicationId && this.video) {
      this.submittedPostsService.getModernBriefApplicationSinglePost(this.applicationId, this.video.id).pipe(take(1)).subscribe((submittedPostRes: SubmittedPostDto) => {
        console.log('🚨 IndividualPost - Comments -> ngOnInit: ', submittedPostRes);

        this.submittedPost.set(submittedPostRes);

        if (submittedPostRes) {

          let ss_submittedPost: any;

          if (submittedPostRes.resultsVersion == SubmittedPostVersionEnum.SuperSocial) {
            ss_submittedPost = submittedPostRes;
          }


          if (ss_submittedPost) {
            const lookupIds = [
              ss_submittedPost.ss_post_id,
              ss_submittedPost.fullUrl,
              ss_submittedPost.videoLink,
            ].filter((id: unknown): id is string => typeof id === 'string' && id.length > 0);
            this.getSuperSocialResults(lookupIds);
          }
        } else {
          this.noSubmittedPosts.set(true);
        }
      });
    } else {
      console.log('Comments - No Application.... ');
      this.noSubmittedPosts.set(true);
    }
  }

  getSuperSocialResults(postIds: string[]) {
    if (!postIds.length) {
      return;
    }
    console.log('-->> submittedPostIds: ', postIds);

    this.superSocialService.getLatestResultsForPosts(postIds).subscribe({
      next: superSocialResultsRes => {
        this.superSocialResults.set(superSocialResultsRes);

        console.log('🤢🤢🤢 superSocialResultsRes: ', superSocialResultsRes);

        this.arrangeTheComments();
      },
      error: error => {
        console.error('superSocialResultsRes Error: ', error);
      }
    })
  }

  arrangeTheComments() {
    if (this.superSocialResults()) {
      Object.keys(this.superSocialResults()).forEach((result: any) => {
        this.individualResult.set(this.superSocialResults()[result]);
      });
    }
    console.log('🤢🤢🤢 individualResult: ', this.individualResult);
  }
}
